import React from 'react';
import { CheckCircle, XCircle, Trash2, Loader, Check, Ban } from 'lucide-react';
import { useDevis } from '../context/DevisContext';
import { formatQuantities } from '../utils/formatters';

const DevisCardList = () => {
  const {
    currentQuotes,
    expandedQuantities,
    processingQuotes,
    confirmLoading,
    toggleQuantityExpansion,
    obfuscateEmail,
    getStatusColor,
    getStatusText,
    openImageModal,
    openRejectModal,
    openDeleteModal,
    confirmQuote
  } = useDevis();

  if (currentQuotes.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4 px-4 py-2">
      {currentQuotes.map((quote) => (
        <div
          key={quote.id}
          className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden"
        >
          <div className="p-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-medium text-gray-900">{quote.name}</h3>
              <span
                className={`px-2 py-1 text-xs rounded-full ${getStatusColor(
                  quote.status
                )}`}
              >
                {getStatusText(quote.status)}
              </span>
            </div>

            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-500">Email:</span>
                <span className="text-gray-700">{obfuscateEmail(quote.email)}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Téléphone:</span>
                <span className="text-gray-700">{quote.phone || "Non spécifié"}</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-500">Quantité:</span>
                <div>{formatQuantities(quote, expandedQuantities, toggleQuantityExpansion)}</div>
              </div>

              {quote.logo_base64 && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">Logo:</span>
                  <img
                    src={quote.logo_base64}
                    alt="Logo"
                    className="h-8 w-8 object-contain cursor-pointer"
                    onClick={() => openImageModal(quote.logo_base64)}
                  />
                </div>
              )}
            </div>

            <div className="mt-4 pt-3 border-t border-gray-100 flex justify-end space-x-2">
              {processingQuotes.includes(quote.id) || confirmLoading === quote.id ? (
                <Loader className="w-5 h-5 text-blue-600 animate-spin" />
              ) : (
                <>
                  {quote.status === "pending" && (
                    <>
                      <button
                        onClick={() => confirmQuote(quote.id)}
                        className="p-2 text-green-600 hover:bg-green-50 rounded-full"
                        title="Confirmer le devis"
                      >
                        <CheckCircle className="w-5 h-5" />
                      </button>
                      <button
                        onClick={() => openRejectModal(quote.id)}
                        className="p-2 text-red-600 hover:bg-red-50 rounded-full"
                        title="Refuser le devis"
                      >
                        <XCircle className="w-5 h-5" />
                      </button>
                      <button
                        onClick={() => openDeleteModal(quote.id)}
                        className="p-2 text-gray-600 hover:bg-gray-50 rounded-full"
                        title="Supprimer le devis"
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    </>
                  )}

                  {quote.status === "confirmed" && (
                    <>
                      <button className="p-2 text-green-600 rounded-full cursor-default">
                        <Check className="w-5 h-5" title="Devis confirmé" />
                      </button>
                      <button
                        onClick={() => openDeleteModal(quote.id)}
                        className="p-2 text-gray-600 hover:bg-gray-50 rounded-full"
                        title="Supprimer le devis"
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    </>
                  )}

                  {quote.status === "rejected" && (
                    <>
                      <button className="p-2 text-red-600 rounded-full cursor-default">
                        <Ban className="w-5 h-5" title={`Devis refusé: ${quote.rejection_reason}`} />
                      </button>
                      <button
                        onClick={() => openDeleteModal(quote.id)}
                        className="p-2 text-gray-600 hover:bg-gray-50 rounded-full"
                        title="Supprimer le devis"
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DevisCardList;